import { useEffect, useState } from "react";
import { Feather, Compass, Tractor, Leaf, Landmark, Microscope, HardHat, Hammer, Users } from "lucide-react";
import { fetchPartners } from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";

const ICONS = { Feather, Compass, Tractor, Leaf, Landmark, Microscope, HardHat, Hammer, Users };

export default function PartnersPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { fetchPartners().then(setItems).catch(() => {}); }, []);

  return (
    <div data-testid="page-partners" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <SectionHeader
        overline="Who we work with"
        title={<>A continent-wide <span className="italic text-ra-ochre">community of practice</span>.</>}
        lede="Restoration cannot be done alone. We work alongside Traditional Owners, Ranger groups, landholders, researchers, agencies and industry to deliver landscape-scale recovery."
        testId="partners-header"
      />

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ra-line border border-ra-line ra-stagger">
        {items.map((p) => {
          const Icon = ICONS[p.icon] || Users;
          return (
            <div
              key={p.id}
              data-testid={`partner-card-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
              className="bg-ra-bone p-8 lg:p-10 flex flex-col gap-5 hover:bg-ra-paper transition-colors duration-300"
            >
              <Icon size={32} className="text-ra-ochre" strokeWidth={1.3} />
              <div>
                <h3 className="ra-serif text-2xl lg:text-3xl leading-tight">{p.name}</h3>
                <p className="mt-3 text-ra-soft leading-relaxed">{p.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
